var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.wrapClasses }, [
    !_vm.controlsOutside
      ? _c("div", { class: _vm.handlerClasses }, [
          _c("a", { class: _vm.upClasses, on: { click: _vm.up } }, [
            _c("span", {
              class: _vm.innerUpClasses,
              on: { click: _vm.preventDefault }
            })
          ]),
          _vm._v(" "),
          _c("a", { class: _vm.downClasses, on: { click: _vm.down } }, [
            _c("span", {
              class: _vm.innerDownClasses,
              on: { click: _vm.preventDefault }
            })
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.controlsOutside
      ? _c(
          "div",
          {
            staticClass:
              "ivu-input-number-controls-outside-btn ivu-input-number-controls-outside-down",
            class: {
              "ivu-input-number-controls-outside-btn-disabled": _vm.downDisabled
            },
            on: { click: _vm.down }
          },
          [_c("i", { staticClass: "ivu-icon ivu-icon-ios-remove" })]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.controlsOutside
      ? _c(
          "div",
          {
            staticClass:
              "ivu-input-number-controls-outside-btn ivu-input-number-controls-outside-up",
            class: {
              "ivu-input-number-controls-outside-btn-disabled": _vm.upDisabled
            },
            on: { click: _vm.up }
          },
          [_c("i", { staticClass: "ivu-icon ivu-icon-ios-add" })]
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { class: _vm.inputWrapClasses }, [
      _c("input", {
        class: _vm.inputClasses,
        attrs: {
          id: _vm.elementId,
          disabled: _vm.itemDisabled,
          autocomplete: "off",
          spellcheck: "false",
          autofocus: _vm.autofocus,
          readonly: _vm.readonly || !_vm.editable,
          name: _vm.name,
          placeholder: _vm.placeholder
        },
        domProps: { value: _vm.formatterValue },
        on: {
          focus: _vm.focus,
          blur: _vm.blur,
          keydown: function($event) {
            $event.stopPropagation()
            return _vm.keyDown.apply(null, arguments)
          },
          input: _vm.change,
          mouseup: _vm.preventDefault,
          change: _vm.change
        }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-07f1e4f6", { render: render, staticRenderFns: staticRenderFns })
  }
}